export var noop = function () { };
export function on(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.addEventListener) {
        obj.addEventListener.apply(obj, args);
    }
}
export function off(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.removeEventListener) {
        obj.removeEventListener.apply(obj, args);
    }
}
export var isBrowser = typeof window !== 'undefined';
export var isNavigator = typeof navigator !== 'undefined';



//////////////////
// WEBPACK FOOTER
// ./~/react-use/esm/misc/util.js
// module id = 14
// module chunks = 2